import React, { useEffect, useState } from "react";
import "./Career.css";
import heroImg from "../assets/career.png";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";

function Career() {

  const [jobs, setJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);

  const [keyword, setKeyword] = useState("");
  const [location, setLocation] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchJobs = async () => {
      try {

        const q = query(
          collection(db, "jobs"),
          orderBy("createdAt", "desc")
        );

        const snapshot = await getDocs(q);

        const jobList = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setJobs(jobList);
        setFilteredJobs(jobList);

      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };

    fetchJobs();
  }, []);


  // SEARCH FUNCTION
  const handleSearch = () => {

    const result = jobs.filter((job) => {

      const titleMatch =
        job.title?.toLowerCase().includes(keyword.toLowerCase());

      const locationMatch =
        job.location?.toLowerCase().includes(location.toLowerCase());

      return titleMatch && locationMatch;
    });

    setFilteredJobs(result);
  };


  return (
    <div className="career-page">

      {/* HERO SECTION */}
      <section className="career-hero">

        <div className="hero-left">

          <h1>
            Find The Most <br />
            <span>Exciting Startup Jobs</span>
          </h1>

          <p>
            We help you to build a better future.
            Find your dream role today.
          </p>

          <div className="search-container">

            <input
              type="text"
              placeholder="Job title or keyword"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />

            <input
              type="text"
              placeholder="Select location"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
            />

            <button onClick={handleSearch}>
              Search Job
            </button>

          </div>

        </div>

        <div className="hero-right">
          <div className="image-card">
            <img src={heroImg} alt="career" />
          </div>
        </div>

      </section>


      {/* JOB LIST SECTION */}
      <section className="job-list-section">

        <h2>Latest Job Openings</h2>

        <div className="job-grid">

          {filteredJobs.length === 0 ? (
            <p className="no-job">No jobs found.</p>
          ) : (

            filteredJobs.map((job) => (

              <div className="job-card" key={job.id}>

                <h3>{job.title}</h3>

                <p className="job-desc">{job.description}</p>

                <div className="job-info">
                  <span>📍 {job.location}</span>
                  <span>💼 {job.type}</span>
                </div>

                {job.salary && (
                  <p className="salary">💰 {job.salary}</p>
                )}

                <button
                  className="apply-btn"
                  onClick={() => navigate(`/apply/${job.id}`)}
                >
                  Apply Now
                </button>

              </div>

            ))

          )}

        </div>

      </section>

    </div>
  );
}

export default Career;